import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const order = {
  orders: (params) => {
    const url = api.order.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  insufficientPayment: (params) => {
    const url = api.order.insufficientPayment + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  insufficientPaymentDetail: (orderId) => {
    const url = api.order.insufficientPaymentDetail(orderId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  paymentConfirm: (orderId, payloads) => {
    const url = api.order.paymentConfirm(orderId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  orderDetail: (orderId) => {
    const url = api.order.detail(orderId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  processOrder: (orderId) => {
    const url = api.order.processOrder(orderId)
    return baseURL.post(url, {}, { headers: getAuthHeader() })
  },
  rejectOrder: (orderId, payloads) => {
    const url = api.order.rejectOrder(orderId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  updateShipmentStatus: (orderId, payloads) => {
    const url = api.order.updateShipment(orderId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  cancelOrder: (orderId, payloads) => {
    const url = api.order.cancel(orderId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  priceAdjustments: (params) => {
    const url = api.order.priceAdjustments + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  completePriceAdjustment: (orderId) => {
    const url = api.order.completePriceAdjustment(orderId)
    return baseURL.post(url, {}, { headers: getAuthHeader() })
  },
  rejectPriceAdjustment: (orderId) => {
    const url = api.order.rejectPriceAdjustment(orderId)
    return baseURL.post(url, {}, { headers: getAuthHeader() })
  },
  retryShipment: (orderId) => {
    const url = api.order.retryShipment(orderId)
    return baseURL.post(url, {}, { headers: getAuthHeader() })
  }
}
export default order
